export default (userRoles) => {
  return userRoles
    .filter(function (el) {
      return el != 'Customer Success Lead';
    })
    .filter(function (el) {
      return el != 'Customer Success Director';
    });
};
